<template>
  <div class="panel">
    <template v-if="slots.titlebar">
      <div class="panel-titlebar">
        <slot name="titlebar" />
      </div>
    </template>
    <template v-if="slots.toolbar">
      <div class="panel-toolbar">
        <slot name="toolbar" />
      </div>
    </template>
    <template v-if="slots.extrabar && showExtrabar">
      <div class="panel-extrabar">
        <slot name="extrabar" />
      </div>
    </template>
    <slot />
    <div class="content">
      <slot name="content" />
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">

withDefaults(
  defineProps<{
    background?: string
    showExtrabar?: boolean
  }>(),
  {
    background: 'white',
    showExtrabar: false,
  },
)

const slots = defineSlots<{
  titlebar?: (props: any) => any
  toolbar?: (props: any) => any
  extrabar?: (props: any) => any
  content?: (props: any) => any
  footer?: (props: any) => any
}>()
</script>

<style scoped>
.panel {
  background-color: v-bind(background);
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  max-height: 100vh;
}
.content {
  flex-grow: 1;
  overflow-y: auto;
}
.panel-extrabar {
  box-shadow: 0 4px 4px 0 #00000040;
  z-index: 1;
}
</style>
